import styled from 'styled-components';

export const StyledTransportListItem = styled.div`
  display: flex;
  padding: 12px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  cursor: pointer;
  gap: 12px;

  &:hover {
    background: ${({ theme }) => theme.colors.foreground};
  }
`;

export const NotificationBubble = styled.div`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primaryBase};
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;

  /* small/regular */
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.secondaryText};
  background-color: ${({ theme }) => theme.colors.foreground};
  width: fit-content;
`;

export const TransportIconWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TransportDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: 4px;
`;

export const DetailRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
`;
